<template>
  <div class="icon-section">
    <MyAppIcon v-for="(item,index) in icons" :key="item.id"
               :item="item" :cell="cell" :order="index"></MyAppIcon>
  </div>
</template>

<script>
import MyAppIcon from "@/views/MyAppIcon.vue";

export default {
  name: 'MyAppGrid',
  components: {
    MyAppIcon
  },
  data() {
    return {
      cell: {//每个单元格大小
        height: 120,
        width: 120
      },
      isSimpleRoute:false,
      isSuperAdmin:false,
    }
  },
  computed: {
    icons() {
      let list = this.$store.state.core.applications;
      if(this.isSuperAdmin === true){
        return list;
      }
      let data = [];
      for (let item of list) {
        if(this.isSimpleRoute === true){
          if(item.id !== 'bu_repair_center' && item.id !== 'bu_cs_center'){
            data.push({...item});
          }
        }else{
          if(item.id !== 'bu_repair_center_simple_repair'){
            data.push({...item});
          }
        }
      }
      return data;
    }
  },
  async created() {

  },

  methods: {

  },
};
</script>

<style lang="less" scoped>

.icon-section {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}

</style>
